// 设置方法
import { setdate } from '@/utils/timerest'
import { PopupManager } from 'element-ui/lib/utils/popup'
import { rejecthttp, changeflagCLOSED } from "@/utils/request";

export const minxins1 = {
  data() {
    return {
      setdate: setdate
    }
  },
  methods: {
    // 调用这个方法，返回排好序的数组以v1,v2排序
    arriscon(v, v1, v2, v3,v4,v5) {
      let c = JSON.parse(JSON.stringify(v))
      // 升序排列
      c = c.sort((a, b) => a.from < b.from ? -1 : 1)
      // 插入
      c.push({ from: v1, to: v2, number: v3 ,isopen:v4,staffenable:v5})
      let len = c.length
      if (len == 1) {
        return c.sort((a, b) => a.from < b.from ? -1 : 1)
      }
      let i = 0
      // 当c[i].from大于v1时判断插入，哨兵算法
      for (i; c[i].from < v1; i++) {
      }
      if (len == i) {
        return -1
      } else {
        if (i > 0) {
          // 判断插入
          if (c[i - 1].to <= v1 && (c[i].from >= v2 || len == (i + 1))) {
            return c.sort((a, b) => a.from < b.from ? -1 : 1)
          } else {
            return -1
          }
        } else {
          if (c[i].from >= v2) {
            return c.sort((a, b) => a.from < b.from ? -1 : 1)
          } else {
            return -1
          }
        }

      }
    },
    // '00:00'to0
    mton(v) {
      try {
        let arr = v.split(':')
        return ((arr[0] - 0) * 60 + (arr[1] - 0))
      } catch (e) {

      }

    },
    // 时间转换函数
    numbertomus(v) {
      try {
        let h = Math.floor(v / 60)
        let hh = h > 9 ? h : '0' + h
        let m = (v % 60)
        let mm = m > 9 ? m : '0' + m
        return hh + ':' + mm
      } catch (e) {

      }

    },
    // 转码
    // 1是转成字符串
    rowformate(v, i) {
      let c = []
      let d = []
      v.forEach(it => {
        c.push({ from: this.numbertomus(it.from), to: this.numbertomus(it.to), number: it.number ,isopen:it.isopen,staffenable:it.staffenable})
        d.push({ from: this.mton(it.from), to: this.mton(it.to), number: it.number ,isopen:it.isopen,staffenable:it.staffenable})
      });
      return i == 1 ? c : d
    },
    // 转码
    datatoshow(v) {
      let c = ''
      v.forEach(it => {
        c += this.numbertomus(it.from) + ' - ' + this.numbertomus(it.to) + '； '
      });
      return c
    },
  }
}
// 当用户额外数据需要的时候
let accountdata = []
// 换数据
export function pushdata(data) {
  accountdata = data
}
export function idtoname(id) {
  let c = accountdata.find(it => it.backaccountid == id)
  if (c) {
    return c.name

  }
  return ''
}
// 自定义的确认框，默认值,是否有取消按钮，是否有弹窗
export function confirmmy(that, { title = 'title', conback = () => { }, canback = () => { }, contitle = '确认', cancletitle = '取消', iscancel = true, isprop = true } = {}) {
  // PopupManager.zIndex = 6000
  console.log(35764335754357432565335654313)
  if (iscancel) {
    that.$confirm(title, '提示', {
      confirmButtonText: '确定',
      type: 'warning',
      customClass: 'messageBoxmy',
      cancelButtonText: '取消'
    }).then(() => {
      conback()
      // PopupManager.zIndex = 2000
      if (isprop) {
        that.$message({
          type: 'success',
          message: contitle
        });
      }

    }).catch(() => {
      canback()
      // PopupManager.zIndex = 2000
      if (isprop) {
        that.$message({
          type: 'info',
          message: cancletitle
        });
      }

    });
  } else {
    that.$alert(title, '提示', {
      confirmButtonText: '确定',

    });
  }
}
// 测试
export function datatest(){
  //   isshow  //是否显示
    //   showFunc   //显示对应的函数
    //   requireFlag 是否必填，需要的提示内容
    //   requireFunc 必填的函数表达式
    //   selectarr 可选的数组
    //   selectSetValueFunc 可选数组的初始化函数
    //   watchKeyList 监控对应key value的数组，
    //   keyWatchList 收集监听我的key的对象的key
    // //   requireFlag 显示提示的信息
    //   requireDesc 是否必填，需要的提示内容
    //   requireFunc 必填的函数表达式
  return {
    // infoset
    testData: [{
      key: 'activityid',
      label: '活动ID',
      value: undefined,
      type: 0,
      isrow: true,
      isshow:true,
      watchKeyList:['name'],
      showFunc(r){
        console.log(this,1234567)
        console.log(r.key,r.value)
        this.isshow = r.value!=='111'?true:false
      },
      
      selectarr:[],
      selectSetValueFunc(){
        console.log(this)
      }
    }, {
      key: 'shopid',
      label: '门店',
      value: 0,
      type: 15,
      isshow:false,

      isrow: true,
      // selectarr: [{key:'全部门店',value:0} ]
    }, {
      key: 'name',
      label: '活动名称',
      value: undefined,
      type: 1,
      isrow: true,
      isshow:true,

      requireFlag:false,
      requireDesc:'活动名称不能为空',
      requireFunc(newvalue){
        if(newvalue=='111'){
          this.requireFlag=true
          return {flag:false,errMsg:'活动名称不能为空2'}
        }else{
          this.requireFlag=false
        }
        // return this.value!==''
      },
    }, {
      key: 'name2',
      label: '活动名称2',
      value: undefined,
      type: 1,
      isrow: true,
      isshow:true,
      requireFlag:false,
      requireDesc:'活动名称不能为空',
      requireFunc(newvalue){
        if(newvalue=='222'){
          this.requireFlag=true
          return {flag:false,errMsg:'活动名称不能为空1'}
        }else{
          this.requireFlag=false
        }
        // return this.value!==''
      },
      // requireflag:'活动名称2不能为空客户端为两个活动名的拼接'
    },
    // {
    //   key: 'showtype',
    //   label: '自定义分类',
    //   value: undefined,
    //   type: 1,
    //   isrow: true,
    //   // requireflag:'自定义分类不能为空，例：线上，线下，2022春季攻势 等'
    // },
    {
      key: 'activitygroup',
      label: '活动类型分组',
      value: null,
      type: 12,
      isshow:true,

      isrow: true,
      selectarr: [],
      selectSetValueFunc(that){
        rejecthttp(false, "get", "/manage/activitygroup/getlist?appid=188", {}, that, (doc) => {
          changeflagCLOSED(doc, false, that);
          if (doc.data.Code == "MSGKEY_OK") {
           
          doc.data.data.forEach(item=>{
            this.selectarr.push({
              key:item.name,
              value:item.groupid
            })
           })
          }
        });
      }
    },
    {
      key: 'state',
      label: '状态',
      isshow:true,

      value: 1,
      type: 2,
      selectarr: [{ key: '测试中', value: 0 }, { key: '开启中', value: 1 }, { key: '关闭中', value: 2 },]
    }, 
    // {
    //   key: 'receivetype',
    //   label: '领取方式',
    //   value: 3,
    //   type: 2,
    //   isrow: true,
    //   selectarr: [ { key: '邮寄', value: 1 }, { key: '门店自提', value: 2 }, { key: '两种方式', value: 3 }],

    // },
    {
      key: 'isshow',
      label: '是否显示',
      value: undefined,
      isshow:true,

      type: 13,
      selectarr: [{ key: '不显示', value: 0 }, { key: '显示', value: 1 }]
    }, {
      key: 'fromdate',
      label: '报名起始时间 ',
      value: undefined,
      type: 3,
      isshow:true,

      isrow: false
    }, {
      key: 'todate',
      label: '报名中止时间',
      value: undefined,
      type: 3,
      isshow:true,

      isrow: false
    }, {
      key: 'img',
      label: '活动图片',
      value: undefined,
      type: 4,
      isshow:true,

      isrow: true
    }, {
      key: 'carousels',
      label: '轮播图',
      value: [],
      type: 17,
      isshow:true,

      isrow: true
    }, {
      key: 'infoimg',
      label: '活动详情图（海报长图）',
      value: undefined,
      type: 15,
      isshow:false,

      isrow: true
    }, {
      key: 'mainlogo',
      label: '总文字图标',
      value: undefined,
      isshow:false,

      // type: 5,
      type: 15,
      isrow: true
    }, {
      key: 'brancheslogo',
      label: '子文字图标',
      value: undefined,
      isshow:false,

      // type: 5,
      type: 15,
      isrow: true
    }, {
      key: 'activitieinfo',
      label: '活动描述 ',
      value: undefined,
      isshow:true,

      type: 6,
      isrow: true
    }, {
      key: 'url',
      label: '自定义URL ',
      isshow:false,

      value: undefined,
      // type: 6,
      type: 15,
      isrow: true
    }, {
      key: 'participatecount',
      label: '参与次数统计',
      value: undefined,
      isshow:true,

      type: 0,
      isrow: false
    }, {
      key: 'completedcount',
      label: '完成次数统计',
      value: undefined,
      isshow:true,

      type: 0,
      isrow: false
    }, {
      key: 'createid',
      label: '创建者',
      value: undefined,
      isshow:true,

      type: 0,
      isrow: false
    }, {
      key: 'createdate',
      label: '创建日期',
      value: undefined,
      isshow:true,

      type: 0,
      isrow: false
    }, {
      key: 'editid',
      label: '更新者',
      value: undefined,
      isshow:true,

      type: 0,
      isrow: false
    }, {
      key: 'editdate',
      label: '更新日期',
      value: undefined,
      isshow:true,

      type: 0,
      isrow: false
    },],
    // testData2:参加条件设置
    testData2: [
      // {
      //   key: 'activitygroup',
      //   label: '活动类型分组',
      //   value: null,
      //   type: 12,
      //   isrow: true,
      //   selectarr: []
      // },
      {
        key: 'groupchecktype',
        label: '重置参与次数类型',
        value: 1,
        // type: 2,
        type: 2,
        isshow:true,
        isrow: true,
        selectarr: [
          {
          key:'不参与检查',value:0,isselectby: 'this.arrivecondition[0].value<=10'},
          {
            key:'参与检查',value:1,isselectby: 'this.arrivecondition[0].value<=10'},
      ],
      },
      {
        key: 'needshopid',
        label: '是否需要选择门店',
        value: 0,
        // type: 2,
        type: 2,
      isshow:true,

        isrow: true,
        selectarr: [
          {
          key:'不需要',value:0,isselectby: 'this.arrivecondition[0].value<=10'},
          {
            key:'需要',value:1,isselectby: 'this.arrivecondition[0].value<=10'},
      ],
      },
      {
        key: 'shopidtype',
        label: '门店设置',
        value: 0,
        // type: 2,
        type: 2,
      isshow:true,

        isrow: true,
        selectarr: [
          {
          key:'全部',value:0,isselectby: 'this.arrivecondition[0].value<=10'},
          {
            key:'指定门店',value:1,isselectby: 'this.arrivecondition[0].value<=10'},
            {
              key:'指定大区',value:2,isselectby: 'this.arrivecondition[0].value!=5'},
      ],
      },
      {
        key: 'shops',
        label: '',
        value: [],
        // type: 2,
        type: 21,
        relate:-1,
      isshow:false,
        show:1,
        isrow: true,
        watchKeyList:['shopidtype'],
        showFunc(r){
          // console.log(this,1234567)
          // console.log(r.key,r.value)
          this.isshow = r.value!==0?true:false
        },
      },
      {
        key: 'maxparticipatetimes',
        label: '全局参加次数限制',
        value: 0,
        type: 7,
      isshow:true,

        isrow: true,
        remark: '0代表不限制人数'
      },
      {
        key: 'singleparticipatetimes',
        label: '单人参加次数限制',
        value: 1,
        type: 7,
      isshow:true,

        isrow: true,
        remark: '0代表不限制次数'
      }, {
        key: 'singleparticipatepoint',
        label: '单人获取点数限制',
        value: 0,
        type: 7,
      isshow:true,

        isrow: true,
        remark: '与完成子任务的点数相关'
      }, {
        key: 'resettimestype',
        label: '重置参与次数类型',
        value: 0,
        // type: 2,
        type: 2,
      isshow:true,

        isrow: true,
        selectarr: [{ key: '手动重置', value: 0,isselectby: 'this.arrivecondition[0].value<=10' }, 
        { key: '按指定天数', value: 1 ,isselectby: 'this.arrivecondition[0].value<=10'},
         { key: '按自然周', value: 2 ,isselectby: 'this.arrivecondition[0].value<=10'},
          { key: '按自然月', value: 3 ,isselectby: 'this.arrivecondition[0].value<=10'},
          { key: '按自然年', value: 4 ,isselectby: 'this.arrivecondition[0].value<=10'}],
      }, {
        key: 'resettimesparam',
        label: '重置参与次数参数',
        value: undefined,
        // type: 7,
        type: 7,
      isshow:true,

        isrow: true,
      },
      {
        key: 'datasourceid',
        label: '设置条件表达式',
        value: undefined,
        type: 8,
      isshow:true,

        isrow: true,
      }, {
        key: 'appointmentid',
        label: '预约设置',
        value: undefined,
        type: 9,
      isshow:true,

        isrow: true,
      }, {
        key: 'cancellimitminute',
        label: '预约取消的提前量',
        value: undefined,
        type: 16,
      isshow:true,

        isrow: true,
      }, {
        key: 'cancellimittimes',
        label: '允许取消再参加次数',
        value: null,
        type: 7,
        isshow:true,

        isrow: true,
      },
      {
        key: 'prizechancemode',
        label: 's',
        value: 0,
        type: 99,
        isshow:false,

        isrow: true,
      },
      {
        key: 'costpoints',
        label: 's',
        value: 0,
        isshow:false,

        type: 99,
        isrow: true,
      },
      {
        key: 'checkstock',
        label: '检查库存',
        value: undefined,
        type: 13,
      isshow:true,

        selectarr: [{ key: '不检查', value: 0 }, { key: '检查', value: 1 }]
      },
      {
        key: 'needaddress',
        label: '需要收货人信息',
        value: undefined,
      isshow:true,

        type: 13,
        isrow: true,
        selectarr: [{ key: '不需要', value: 0 }, { key: '需要', value: 1 }],
      },

      {
        key: 'participatenotifytype',
        label: '参加成功的通知方式',
        value: 0,
        type: 2,
      isshow:true,

        isrow: true,
        selectarr: [{ key: '不通知', value: 0 }, 
        { key: '短信', value: 1 },
         { key: '邮件', value: 2 },
          { key: '微信模板消息', value: 3 }, 
          { key: '小程序订阅消息', value: 4 }],
      },
      {
        key: 'participatemsg',
        label: '参加成功的模板消息',
        value: undefined,
        isshow:false,
        type: 6,
        isrow: true,
        watchKeyList:['participatenotifytype'],
        showFunc(r){
          // console.log(this,1234567)
          // console.log(r.key,r.value)
          this.isshow = r.value!==0?true:false
        },
      }, 
      {
        key: 'appointmentremindtype',
        label: '预约提醒的通知方式',
        value: 0,
        type: 2,
      isshow:true,

        isrow: true,
        selectarr: [{ key: '不通知', value: 0 },
         { key: '短信', value: 1 }, 
         { key: '邮件', value: 2},
          { key: '微信模板消息', value: 3 }, 
          { key: '小程序订阅消息', value: 4 },],
      },
      {
        key: 'remindadvence',
        label: '预约提醒的提前量',
        value: undefined,
        isshow:false,
        type: 16,
        isrow: true,
        watchKeyList:['appointmentremindtype'],
        showFunc(r){
          // console.log(this,1234567)
          // console.log(r.key,r.value)
          this.isshow = r.value!==0?true:false
        },
      },
      {
        key: 'appointmentremindmsg',
        label: '预约提醒的模板消息',
        value: undefined,
        isshow:false,
        type: 6,
        isrow: true,
        watchKeyList:['appointmentremindtype'],
        showFunc(r){
          // console.log(this,1234567)
          // console.log(r.key,r.value)
          this.isshow = r.value!==0?true:false
        },
      },],
      // 完成条件设置
    testData3:[
      {
        key: 'completecondition',
        label: '完成活动条件',
        value: 5,
        type: 2,
        isshow:true,

        isrow: true,
        funcreturn: 'this.arrivecondition[0].value==5?this.prizeset[0].value=1:""',
        selectarr: [{ key: '手动审核判定', value: 1,isselectby: 'this.arrivecondition[0].value!=5'},
         { key: '完成全部子任务', value: 2 ,isselectby: 'this.arrivecondition[0].value!=5'},
          { key: '完成任意子任务', value: 3,isselectby: 'this.arrivecondition[0].value!=5' },
          { key: '达到指定的进度率', value: 4 ,isselectby: 'this.arrivecondition[0].value!=5'},
           { key: '立即完成并领奖', value: 5 ,isselectby: 'this.arrivecondition[0].value<=10'},],
        // selectarr: [{ key: '立即完成并领奖', value: 5 },],
      },
      // 当上一条的value是4时显示
      {
        key: 'completeconditiondegreemax',
        label: '指定的进度率',
        value: undefined,
        type: 7,
        // type: 15,
        isshow:false,

        isrow: true,
        watchKeyList:['completecondition'],
        showFunc(r){
          // console.log(this,1234567)
          // console.log(r.key,r.value)
          this.isshow = r.value===4?true:false
        },
      }, 
      {
        key: 'sonTaskList',
        label: '子任务列表',
        isshow:true,

        value: [],
        type: 10,
        watchKeyList:['completecondition'],
        showFunc(r){
          // console.log(this,1234567)
          // console.log(r.key,r.value)
          this.isshow = r.value>=2?true:false
        },
        isrow: true,
      },
    ],
    // 活动子表
    testData5:[{
      key: 'datasource',
      label: '设置条件表达式',
      value: undefined,
      isshow:true,

      type: 8,
      isrow: true,
    }, {
      key: 'activitieinfo',
      label: '活动描述',
      isshow:true,

      value: undefined,
      type: 6,
      isrow: true,
    }, {
      key: 'img',
      label: '主图',
      value: undefined,
      isshow:true,

      type: 4,
      isrow: true,
    }, {
      key: 'mainlogo',
      label: '活动总文字图标',
      isshow:true,

      value: undefined,
      type: 5,
      isrow: true,
    },
    {
      key: 'brancheslogo',
      label: '活动子文字图标',
      value: undefined,
      isshow:true,

      type: 5,
      isrow: true,
    },
    {
      key: 'name',
      label: '子任务名称',

      value: undefined,
      type: 1,
      isshow:true,

      isrow: true,
    }, {
      key: 'degree',
      label: '完成获得进度',
      value: undefined,
      type: 7,
      isshow:true,

      isrow: true,
    }, {
      key: 'triggertype',
      label: '触发类型',
      value: undefined,

      isshow:true,
      type: 2,
      isrow: true,
      selectarr: [{ key: '人工识别', value: 0 }, { key: '下单', value: 1 }, { key: '事件', value: 2 }, { key: '表单', value: 3 }],
    },

    ],
    // 奖励编辑区表
    testData4:[
      {
        key: 'name',
        label: '*奖品名称',
        value: undefined,
        isshow:true,

        type: 1,
        isrow: true,
      },
      {
        key: 'img',
        label: '奖品图标',
        value: undefined,
        isshow:true,

        type: 4,
        isrow: true,
      }, {
        key: 'state',
        label: '状态',
        value: undefined,
        isshow:true,

        type: 2,
        isrow: true,
        selectarr: [{ key: '正常', value: 0 }, { key: '已领完', value: 1 }, { key: '隐藏', value: 2 }],
      },
      {
        key: 'receivetype',
        label: '领取方式',
        value: 3,
        isshow:true,

        type: 2,
        isrow: true,
        selectarr: [ { key: '邮寄', value: 1 }, { key: '门店自提', value: 2 }, { key: '两种方式', value: 3 }],

      },
      {
        key: 'info',
        label: '信息',
        value: undefined,
        isshow:true,

        type: 6,
        isrow: true,
      },
      {
        key: 'type',
        label: '奖品类型',
        value: undefined,
        type: 12,
        isshow:true,

        isrow: true,
        selectarr: [{ key: '空奖', value: 0 }, { key: '核销签到', value: 1 }, { key: 'URL（固定壁纸二维码或外部链接） ', value: 2 }, { key: '发放积分', value: 3 }, { key: '生成优惠券', value: 4 }, { key: '立即生成订单', value: 5 },{ key: '核销生成订单', value: 6 }],
      },
      {
        key: 'apiurl',
        label: '回调CRM时的URL',
        value: undefined,
        relate: -1,
        isshow:true,

        show: 2,
        type: 6,
        isrow: true,
      },
      {
        key: 'couponmodelid',
        label: '优惠券模板ID',
        value: undefined,
        relate: -2,
        show: 4,
        isshow:true,

        type: 25,
        isrow: true,
      },
      {
        key: 'imgreward',
        label: '作为奖品的图片',
        value: undefined,
        isshow:true,

        relate: -3,
        show: 2,
        type: 4,
        isrow: true,
        desc: '例如：壁纸，二维码图片(尺寸175*175)'
      }, 
      {
        key: 'qrcodeparam',
        label: '动态二维码',
        value: undefined,
        relate: -4,
        show: 4,
        isshow:true,

        type: 12,
        isrow: true,
        selectarr: [{ key: 'userID', value: 0 }, { key: '参加活动的流水单号', value: 1 }, { key: 'unionID', value: 2 }, { key: '企微外部用户ID', value: 3 }, { key: '专属客服ID', value: 4 }, { key: '优惠券ID', value: 5 }],

      },
      {
        key: 'pointgroupid',
        label: '积分组',
        value: undefined,
        relate: -5,
        isshow:true,

        show: 3,
        type: 12,
        isrow: true,
        selectarr: [],
        selectSetValueFunc(that){
          rejecthttp(false, "get", "/manage/point/pointgrouplist?appid=188&search=", {}, that, (doc) => {
            changeflagCLOSED(doc, false, that);
            if (doc.data.Code == "MSGKEY_OK") {
             
            doc.data.data.forEach(item=>{
              this.selectarr.push({
                key:item.name,
                value:item.groupid
              })
             })
            }
          });
        }
      },
      
      {
        key: 'writeofftemplateid',
        label: '核销模板',
        value: undefined,
        isshow:true,

        type: 12,
        isrow: true,
        selectarr: [],
        selectSetValueFunc(that){
          rejecthttp(false, "get", "/manage/writeoff/getlist?appid=188", {}, that, (doc) => {
            changeflagCLOSED(doc, false, that);
            if (doc.data.Code == "MSGKEY_OK") {
              // this.tableData=doc.data.data
            //  let i= this.findIndex(this.rewardedittable,'pointgroupid')
            //  let r=[]
            doc.data.data.forEach(item=>{
              this.selectarr.push({
                key:item.name,
                value:item.id
              })
             })
            
            }
          });
        }
      },
      {
        key: 'commodityid',
        label: '商品',
        value: undefined,
        isshow:true,

        relate: -7,
        show: [5,6],
        type: 26,
        isrow: true,

      },
      {
        key: 'calstock',
        label: '计算库存',
        isshow:true,

        value: 0,
        type: 2,
        isrow: true,
        selectarr: [{ key: '不计算', value: 0 }, { key: '计算', value: 1 }, { key: '自动同步商品库存', value: 2 }],
      },
      {
        key: 'quantity',
        label: '单次奖品数量',
        value: undefined,
        type: 7,
        isshow:true,
        isrow: true,
        desc: '当奖励类型未积分时，作为积分数量使用'
      }, 
      {
        key: 'datasource',
        label: '设置条件表达式',
        value: undefined,
        type: 8,
        isshow:true,

        isrow: true,
        desc: '仅抽奖模式生效'
      }, {
        key: 'rate',
        label: '抽取概率（%）',
        value: undefined,
        othervalue: undefined,
        iscnm: true,
        isshow:true,

        type: 7,
        isrow: true,
        desc: '仅抽奖模式生效'

      }, {
        key: 'dailymaximum',
        label: '每日最大出奖个数',
        value: undefined,
        type: 7,
        isrow: true,
        isshow:true,

        desc: '仅抽奖模式生效'
      },
      {
        key: 'awardperiodswitch',
        label: '计算出奖时间段',
        value: undefined,
        type: 13,
        isshow:true,

        isrow: true,
        selectarr: [{ key: '不计算', value: 0 }, { key: '计算', value: 1 }],
        desc: '仅抽奖模式生效'

      },
      {
        key: 'awardperiod',
        label: '出奖时间段（0~23h）',
        value: undefined,
        max: 23,
        isshow:true,

        step: 1,
        relate:-1,
        show:1,
        type: 7,
        isrow: true,
        desc: '仅抽奖模式生效'

      },
      {
        key: 'besuretype',
        label: '必出设置',
        isshow:true,

        value: 1,
        type: 13,
        isrow: true,
        selectarr: [{ key: '不设置', value: 0 }, { key: '指定日期', value: 1 }],
        desc: '仅抽奖模式生效'

      },
      
      {
        key: 'besuredate',
        label: '必出日期',
        value: undefined,
        type: 3,
        isrow: true,
        isshow:true,

        desc: '仅抽奖模式生效',
        hastime:true,
        relate:-1,
        show:1,

      },
      {
        key: 'besureaddstep',
        label: '每次抽取后的增加系数',
        value: undefined,
        type: 7,
        isshow:true,

        isrow: true,
        desc: '仅抽奖模式生效',
        relate:-2,
        show:1,
      },
      {
        key: 'getlimit',
        label: '单用户领取次数限制',
        value: undefined,
        type: 7,
        isshow:true,

        isrow: true,
        desc: "0为不限制",
      },
      {
        key: 'point',
        label: '点数',
        value: undefined,
        isshow:true,

        type: 7,
        isrow: true,
        desc: '用来控制用户在单个活动内的领奖总价值'
      },
       {
        key: 'price',
        label: '客户端显示的价格（可选）',
        value: undefined,
        othervalue: undefined,
        iscnm: true,
        type: 7,
        isshow:true,

        isrow: true,
      },
      {
        key: 'playanime',
        label: '中奖动画',
        value: undefined,
        type: 13,
        isshow:true,

        isrow: true,
        selectarr: [{ key: '不播放', value: 0 }, { key: '播放', value: 1 },],
      }, {
        key: 'animeid',
        label: '动画类型',
        value: undefined,
        type: 2,
        relate:-1,
        isshow:true,

        show: 1,
        isrow: true,
        selectarr: [{ key: '没中奖', value: 0 }, { key: '普通小奖', value: 1 }, { key: '二等奖', value: 2 }, { key: '一等奖', value: 3 }, { key: '特等奖', value: 4 }],
      },
      
    ],
    // 奖励表
    testData6:[
      {
        key: 'prizesetting',
        label: '领取奖品设置 ',
        value: 1,
        type: 2,
        isshow:true,
        isrow: true,
        selectarr: [
          { key: '不自动发放', value: 0, isselectby: 'this.arrivecondition[0].value!=5' }, 
          { key: '随机抽取', value: 1, isselectby: 'this.arrivecondition[0].value<=10' }, 
        { key: '用户自选', value: 2, isselectby: 'this.arrivecondition[0].value!=5' },
        { key: '活动结束自动发奖', value: 3, isselectby: 'this.arrivecondition[0].value!=5' },
      
      ],
      },
      // 当上一条的value是4时显示
      {
        key: 'prizemax',
        label: '可领取奖品次数',
        value: 1,
        type: 7,
        isrow: true,
        isshow:true,

        relate: -1,
        showup: 1,
      }, 
      {
        key: 'rewardList',
        label: '奖品列表',
        value: [],
        type: 19,
        isshow:true,
        relate: -2,
        showup: 2,
        isrow: true,
      },
    ],

  }
}
// 数据预约
export function dataappointment() {
  console.log(this, 12345678)
  return JSON.stringify({
    // 基础信息设置,所有字段都绑定在value内，key对应的是发送的数据,只读文本框0,文本框1,单选框2,日期控件3,资源库控件4,小tag5，复数行文本框6,数字选择控件7,条件表达式控件8,
    // 预约设置控件9,表格控件10,小数11,下拉框选择12,是否选择框13，不展示字段15,天时分控件16,轮播图17,只读文本框18andtrans
    infoset: [{
      key: 'activityid',
      label: '活动ID',
      value: undefined,
      type: 0,
      isrow: true
    }, {
      key: 'shopid',
      label: '门店',
      value: 0,
      type: 15,
      isrow: true,
      // selectarr: [{key:'全部门店',value:0} ]
    }, {
      key: 'name',
      label: '活动名称',
      value: undefined,
      type: 1,
      isrow: true,
      requireflag:'活动名称不能为空'
    }, {
      key: 'name2',
      label: '活动名称2',
      value: undefined,
      type: 1,
      isrow: true,
      // requireflag:'活动名称2不能为空客户端为两个活动名的拼接'
    },
    // {
    //   key: 'showtype',
    //   label: '自定义分类',
    //   value: undefined,
    //   type: 1,
    //   isrow: true,
    //   // requireflag:'自定义分类不能为空，例：线上，线下，2022春季攻势 等'
    // },
    {
      key: 'activitygroup',
      label: '活动类型分组',
      value: null,
      type: 12,
      isrow: true,
      selectarr: []
    },
    {
      key: 'state',
      label: '状态',
      value: 0,
      type: 2,
      selectarr: [{ key: '测试中', value: 0 }, { key: '开启中', value: 1 }, { key: '关闭中', value: 2 },]
    }, 
    // {
    //   key: 'receivetype',
    //   label: '领取方式',
    //   value: 3,
    //   type: 2,
    //   isrow: true,
    //   selectarr: [ { key: '邮寄', value: 1 }, { key: '门店自提', value: 2 }, { key: '两种方式', value: 3 }],

    // },
    {
      key: 'isshow',
      label: '是否显示',
      value: undefined,
      type: 13,
      selectarr: [{ key: '不显示', value: 0 }, { key: '显示', value: 1 }]
    }, {
      key: 'fromdate',
      label: '报名起始时间 ',
      value: undefined,
      type: 3,
      isrow: false
    }, {
      key: 'todate',
      label: '报名中止时间',
      value: undefined,
      type: 3,
      isrow: false
    }, {
      key: 'img',
      label: '活动图片',
      value: undefined,
      type: 4,
      isrow: true
    }, {
      key: 'carousels',
      label: '轮播图',
      value: [],
      type: 17,
      isrow: true
    }, {
      key: 'infoimg',
      label: '活动详情图（海报长图）',
      value: undefined,
      type: 15,
      isrow: true
    }, {
      key: 'mainlogo',
      label: '总文字图标',
      value: undefined,
      // type: 5,
      type: 15,
      isrow: true
    }, {
      key: 'brancheslogo',
      label: '子文字图标',
      value: undefined,
      // type: 5,
      type: 15,
      isrow: true
    }, {
      key: 'activitieinfo',
      label: '活动描述 ',
      value: undefined,
      type: 6,
      isrow: true
    }, {
      key: 'url',
      label: '自定义URL ',
      value: undefined,
      // type: 6,
      type: 15,
      isrow: true
    }, {
      key: 'participatecount',
      label: '参与次数统计',
      value: undefined,
      type: 0,
      isrow: false
    }, {
      key: 'completedcount',
      label: '完成次数统计',
      value: undefined,
      type: 0,
      isrow: false
    }, {
      key: 'createid',
      label: '创建者',
      value: undefined,
      type: 0,
      isrow: false
    }, {
      key: 'createdate',
      label: '创建日期',
      value: undefined,
      type: 0,
      isrow: false
    }, {
      key: 'editid',
      label: '更新者',
      value: undefined,
      type: 0,
      isrow: false
    }, {
      key: 'editdate',
      label: '更新日期',
      value: undefined,
      type: 0,
      isrow: false
    },],
    
    // 参加条件设置
    joinset: [
      // {
      //   key: 'activitygroup',
      //   label: '活动类型分组',
      //   value: null,
      //   type: 12,
      //   isrow: true,
      //   selectarr: []
      // },
      {
        key: 'groupchecktype',
        label: '重置参与次数类型',
        value: 1,
        // type: 2,
        type: 2,
        isrow: true,
        selectarr: [
          {
          key:'不参与检查',value:0,isselectby: 'this.arrivecondition[0].value<=10'},
          {
            key:'参与检查',value:1,isselectby: 'this.arrivecondition[0].value<=10'},
      ],
      },
      {
        key: 'needshopid',
        label: '是否需要选择门店',
        value: 0,
        // type: 2,
        type: 2,
        isrow: true,
        selectarr: [
          {
          key:'不需要',value:0,isselectby: 'this.arrivecondition[0].value<=10'},
          {
            key:'需要',value:1,isselectby: 'this.arrivecondition[0].value<=10'},
      ],
      },
      {
        key: 'shopidtype',
        label: '门店设置',
        value: 0,
        type: 2,
        isrow: true,
        selectarr: [
          {
          key:'全部',value:0,isselectby: 'this.arrivecondition[0].value<=10'},
          {
            key:'指定门店',value:1,isselectby: 'this.arrivecondition[0].value<=10'},
            {
              key:'指定大区',value:2,isselectby: 'this.arrivecondition[0].value!=5'},
      ],
      },
      {
        key: 'shops',
        label: '',
        value: [],
        // type: 2,
        type: 21,
        relate:-1,
        show:1,
        isrow: true,
      },
      {
        key: 'maxparticipatetimes',
        label: '全局参加次数限制',
        value: 0,
        type: 7,
        isrow: true,
        remark: '0代表不限制人数'
      },
      {
        key: 'singleparticipatetimes',
        label: '单人参加次数限制',
        value: 1,
        type: 7,
        isrow: true,
        remark: '0代表不限制次数'
      }, {
        key: 'singleparticipatepoint',
        label: '单人获取点数限制',
        value: 0,
        type: 7,
        isrow: true,
        remark: '与完成子任务的点数相关'
      }, {
        key: 'resettimestype',
        label: '重置参与次数类型',
        value: 0,
        // type: 2,
        type: 2,
        isrow: true,
        selectarr: [{ key: '手动重置', value: 0,isselectby: 'this.arrivecondition[0].value<=10' }, 
        { key: '按指定天数', value: 1 ,isselectby: 'this.arrivecondition[0].value<=10'},
         { key: '按自然周', value: 2 ,isselectby: 'this.arrivecondition[0].value<=10'},
          { key: '按自然月', value: 3 ,isselectby: 'this.arrivecondition[0].value<=10'},
          { key: '按自然年', value: 4 ,isselectby: 'this.arrivecondition[0].value<=10'}],
      }, {
        key: 'resettimesparam',
        label: '重置参与次数参数',
        value: undefined,
        // type: 7,
        type: 7,
        isrow: true,
      },
      {
        key: 'datasourceid',
        label: '设置条件表达式',
        value: undefined,
        type: 8,
        isrow: true,
      }, {
        key: 'appointmentid',
        label: '预约设置',
        value: undefined,
        type: 9,
        isrow: true,
      }, {
        key: 'cancellimitminute',
        label: '预约取消的提前量',
        value: undefined,
        type: 16,
        isrow: true,
      }, {
        key: 'cancellimittimes',
        label: '允许取消再参加次数',
        value: null,
        type: 7,
        isrow: true,
      },
      {
        key: 'prizechancemode',
        label: 's',
        value: 0,
        type: 99,
        isrow: true,
      },
      {
        key: 'costpoints',
        label: 's',
        value: 0,
        type: 99,
        isrow: true,
      },
      {
        key: 'checkstock',
        label: '检查库存',
        value: undefined,
        type: 13,
        selectarr: [{ key: '不检查', value: 0 }, { key: '检查', value: 1 }]
      },
      {
        key: 'needaddress',
        label: '需要收货人信息',
        value: undefined,
        type: 13,
        isrow: true,
        selectarr: [{ key: '不需要', value: 0 }, { key: '需要', value: 1 }],
      },

      {
        key: 'participatenotifytype',
        label: '参加成功的通知方式',
        value: 0,
        type: 2,
        isrow: true,
        selectarr: [{ key: '不通知', value: 0,isselectby: 'this.arrivecondition[0].value<=10' }, 
        { key: '短信', value: 1 ,isselectby: 'this.arrivecondition[0].value<=10'},
         { key: '邮件', value: 2 ,isselectby: 'this.arrivecondition[0].value<=10'},
          { key: '微信模板消息', value: 3,isselectby: 'this.arrivecondition[0].value<=10' }, 
          { key: '小程序订阅消息', value: 4 ,isselectby: 'this.arrivecondition[0].value<=10'},],
      },
      {
        key: 'participatemsg',
        label: '参加成功的模板消息',
        value: undefined,
        relate: -1,
        show:[1,2,3,4],
        type: 6,
        isrow: true,
      }, 
      {
        key: 'appointmentremindtype',
        label: '预约提醒的通知方式',
        value: 0,
        type: 2,
        isrow: true,
        selectarr: [{ key: '不通知', value: 0 ,isselectby: 'this.arrivecondition[0].value<=10'},
         { key: '短信', value: 1 ,isselectby: 'this.arrivecondition[0].value<=10'}, 
         { key: '邮件', value: 2,isselectby: 'this.arrivecondition[0].value<=10'},
          { key: '微信模板消息', value: 3 ,isselectby: 'this.arrivecondition[0].value<=10'}, 
          { key: '小程序订阅消息', value: 4,isselectby: 'this.arrivecondition[0].value<=10' },],
      },
      {
        key: 'remindadvence',
        label: '预约提醒的提前量',
        value: undefined,
        relate: -1,
        show:[1,2,3,4],
        type: 16,
        isrow: true,
      },
      {
        key: 'appointmentremindmsg',
        label: '预约提醒的模板消息',
        value: undefined,
        relate: -2,
        show:[1,2,3,4],
        type: 6,
        isrow: true,

      },],
    //完成条件设置
    arrivecondition: [
      {
        key: 'completecondition',
        label: '完成活动条件',
        value: 5,
        type: 2,
        isrow: true,
        funcreturn: 'this.arrivecondition[0].value==5?this.prizeset[0].value=1:""',
        selectarr: [{ key: '手动审核判定', value: 1,isselectby: 'this.arrivecondition[0].value!=5'},
         { key: '完成全部子任务', value: 2 ,isselectby: 'this.arrivecondition[0].value!=5'},
          { key: '完成任意子任务', value: 3,isselectby: 'this.arrivecondition[0].value!=5' },
          { key: '达到指定的进度率', value: 4 ,isselectby: 'this.arrivecondition[0].value!=5'},
           { key: '立即完成并领奖', value: 5 ,isselectby: 'this.arrivecondition[0].value<=10'},],
        // selectarr: [{ key: '立即完成并领奖', value: 5 },],
      },
      // 当上一条的value是4时显示
      {
        key: 'completeconditiondegreemax',
        label: '指定的进度率',
        value: undefined,
        // type: 7,
        type: 15,
        isrow: true,
        relate: -1,
        show: 4,
      }, {
        key: '没有定义',
        label: '子任务列表',
        value: [{
          datasource: undefined,
          detail: {
            activitieinfo: undefined,
            activityid: undefined,
            brancheslogo: undefined,
            datasourceid: undefined,
            degree: undefined,
            detailid: undefined,
            img: undefined,
            mainlogo: undefined,
            name: undefined,
            triggertype: undefined
          }
        }],
        // type: 10,
        type: 15,
        relate: -2,
        showup: 2,
        isrow: true,
      },
    ],
    // 领取奖励设置
    prizeset: [
      {
        key: 'prizesetting',
        label: '领取奖品设置 ',
        value: 1,
        type: 2,
        isrow: true,
        selectarr: [
          { key: '不自动发放', value: 0, isselectby: 'this.arrivecondition[0].value!=5' }, 
          { key: '随机抽取', value: 1, isselectby: 'this.arrivecondition[0].value<=10' }, 
        { key: '用户自选', value: 2, isselectby: 'this.arrivecondition[0].value!=5' },
        { key: '活动结束自动发奖', value: 3, isselectby: 'this.arrivecondition[0].value!=5' },
      
      ],
      },
      // 当上一条的value是4时显示
      {
        key: 'prizemax',
        label: '可领取奖品次数',
        value: 1,
        type: 7,
        isrow: true,
        relate: -1,
        showup: 1,
      }, 
      {
        key: '没有定义',
        label: '奖品列表',
        value: [],
        type: 10,
        relate: -2,
        showup: 2,
        isrow: true,
      },
    ],
    // 活动子表设置绑定到value里面datasourceID需要放在这里
    activitysontable: [{
      key: 'datasource',
      label: '设置条件表达式',
      value: undefined,
      type: 8,
      isrow: true,
    }, {
      key: 'activitieinfo',
      label: '活动描述',
      value: undefined,
      type: 6,
      isrow: true,
    }, {
      key: 'img',
      label: '主图',
      value: undefined,
      type: 4,
      isrow: true,
    }, {
      key: 'mainlogo',
      label: '活动总文字图标',
      value: undefined,
      type: 5,
      isrow: true,
    },
    {
      key: 'brancheslogo',
      label: '活动子文字图标',
      value: undefined,
      type: 5,
      isrow: true,
    },
    {
      key: 'name',
      label: '子任务名称',
      value: undefined,
      type: 1,
      isrow: true,
    }, {
      key: 'degree',
      label: '完成获得进度',
      value: undefined,
      type: 7,
      isrow: true,
    }, {
      key: 'triggertype',
      label: '触发类型',
      value: undefined,
      type: 2,
      isrow: true,
      selectarr: [{ key: '人工识别', value: 0 }, { key: '下单', value: 1 }, { key: '事件', value: 2 }, { key: '表单', value: 3 }],
    },

    ],
    // 奖励编辑区表
    rewardedittable: [
      {
        key: 'name',
        label: '*奖品名称',
        value: undefined,
        type: 1,
        isrow: true,
      },
      {
        key: 'img',
        label: '奖品图标',
        value: undefined,
        type: 4,
        isrow: true,
      }, {
        key: 'state',
        label: '状态',
        value: undefined,
        type: 2,
        isrow: true,
        selectarr: [{ key: '正常', value: 0 }, { key: '已领完', value: 1 }, { key: '隐藏', value: 2 }],
      },
      {
        key: 'receivetype',
        label: '领取方式',
        value: 3,
        type: 2,
        isrow: true,
        selectarr: [ { key: '邮寄', value: 1 }, { key: '门店自提', value: 2 }, { key: '两种方式', value: 3 }],

      },
      {
        key: 'info',
        label: '信息',
        value: undefined,
        type: 6,
        isrow: true,
      },
      {
        key: 'type',
        label: '奖品类型',
        value: undefined,
        type: 12,
        isrow: true,
        selectarr: [{ key: '空奖', value: 0 }, { key: '核销签到', value: 1 }, { key: 'URL（固定壁纸二维码或外部链接） ', value: 2 }, { key: '发放积分', value: 3 }, { key: '生成优惠券', value: 4 }, { key: '立即生成订单', value: 5 },{ key: '核销生成订单', value: 6 }],
      },
      {
        key: 'apiurl',
        label: '回调CRM时的URL',
        value: undefined,
        relate: -1,
        show: 2,
        type: 6,
        isrow: true,
      },
      {
        key: 'couponmodelid',
        label: '优惠券模板ID',
        value: undefined,
        relate: -2,
        show: 4,
        type: 25,
        isrow: true,
      },
      {
        key: 'imgreward',
        label: '作为奖品的图片',
        value: undefined,
        relate: -3,
        show: 2,
        type: 4,
        isrow: true,
        desc: '例如：壁纸，二维码图片(尺寸175*175)'
      }, 
      {
        key: 'qrcodeparam',
        label: '动态二维码',
        value: undefined,
        relate: -4,
        show: 4,
        type: 12,
        isrow: true,
        selectarr: [{ key: 'userID', value: 0 }, { key: '参加活动的流水单号', value: 1 }, { key: 'unionID', value: 2 }, { key: '企微外部用户ID', value: 3 }, { key: '专属客服ID', value: 4 }, { key: '优惠券ID', value: 5 }],

      },
      {
        key: 'pointgroupid',
        label: '积分组',
        value: undefined,
        relate: -5,
        show: 3,
        type: 12,
        isrow: true,
        selectarr: [],

      },
      
      {
        key: 'writeofftemplateid',
        label: '核销模板',
        value: undefined,
        relate: -6,
        show: [1,5,6],
        type: 12,
        isrow: true,
        selectarr: [],

      },
      {
        key: 'commodityid',
        label: '商品',
        value: undefined,
        relate: -7,
        show: [5,6],
        type: 26,
        isrow: true,

      },
      {
        key: 'calstock',
        label: '计算库存',
        value: 0,
        type: 2,
        isrow: true,
        selectarr: [{ key: '不计算', value: 0 }, { key: '计算', value: 1 }, { key: '自动同步商品库存', value: 2 }],
      },
      {
        key: 'quantity',
        label: '单次奖品数量',
        value: undefined,
        type: 71,
        isrow: true,
        desc: '当奖励类型未积分时，作为积分数量使用'
      }, 
      {
        key: 'datasource',
        label: '设置条件表达式',
        value: undefined,
        type: 8,
        isrow: true,
        desc: '仅抽奖模式生效'
      }, {
        key: 'rate',
        label: '抽取概率（%）',
        value: undefined,
        othervalue: undefined,
        iscnm: true,
        type: 7,
        isrow: true,
        desc: '仅抽奖模式生效'

      }, {
        key: 'dailymaximum',
        label: '每日最大出奖个数',
        value: undefined,
        type: 7,
        isrow: true,
        desc: '仅抽奖模式生效'
      },
      {
        key: 'awardperiodswitch',
        label: '计算出奖时间段',
        value: undefined,
        type: 13,
        isrow: true,
        selectarr: [{ key: '不计算', value: 0 }, { key: '计算', value: 1 }],
        desc: '仅抽奖模式生效'

      },
      {
        key: 'awardperiod',
        label: '出奖时间段（0~23h）',
        value: undefined,
        max: 23,
        step: 1,
        relate:-1,
        show:1,
        type: 7,
        isrow: true,
        desc: '仅抽奖模式生效'

      },
      {
        key: 'besuretype',
        label: '必出设置',
        value: 1,
        type: 13,
        isrow: true,
        selectarr: [{ key: '不设置', value: 0 }, { key: '指定日期', value: 1 }],
        desc: '仅抽奖模式生效'

      },
      
      {
        key: 'besuredate',
        label: '必出日期',
        value: undefined,
        type: 3,
        isrow: true,
        desc: '仅抽奖模式生效',
        hastime:true,
        relate:-1,
        show:1,

      },
      {
        key: 'besureaddstep',
        label: '每次抽取后的增加系数',
        value: undefined,
        type: 7,
        isrow: true,
        desc: '仅抽奖模式生效',
        relate:-2,
        show:1,
      },
      {
        key: 'getlimit',
        label: '单用户领取次数限制',
        value: undefined,
        type: 7,
        isrow: true,
        desc: "0为不限制",
      },
      {
        key: 'point',
        label: '点数',
        value: undefined,
        type: 7,
        isrow: true,
        desc: '用来控制用户在单个活动内的领奖总价值'
      },
       {
        key: 'price',
        label: '客户端显示的价格（可选）',
        value: undefined,
        othervalue: undefined,
        iscnm: true,
        type: 7,
        isrow: true,
      },
      {
        key: 'playanime',
        label: '中奖动画',
        value: undefined,
        type: 13,
        isrow: true,
        selectarr: [{ key: '不播放', value: 0 }, { key: '播放', value: 1 },],
      }, {
        key: 'animeid',
        label: '动画类型',
        value: undefined,
        type: 2,
        relate:-1,
        show: 1,
        isrow: true,
        selectarr: [{ key: '没中奖', value: 0 }, { key: '普通小奖', value: 1 }, { key: '二等奖', value: 2 }, { key: '一等奖', value: 3 }, { key: '特等奖', value: 4 }],
      },
      
    ],
  })
}
export function carousels() {
  return JSON.stringify({
    carousels: [{
      key: 'img',
      label: '轮播图',
      value: undefined,
      type: 4,
      isrow: true
    }, {
      key: 'isshow',
      label: '是否显示',
      value: undefined,
      type: 13,
      selectarr: [{ key: '不显示', value: 0 }, { key: '显示', value: 1 }]
    }, {
      key: 'jumptype',
      label: '跳转类型',
      value: undefined,
      type: 12,
      selectarr: [{ key: '不跳转', value: 0 }, { key: '外部小程序', value: 1 }, { key: '内部页面', value: 2 }, { key: '第三方链接', value: 3 }, { key: '活动页', value: 4 }]
    }, {
      key: 'jumpurl',
      label: '跳转链接',
      value: undefined,
      type: 6,
      isrow: true
    }, {
      key: 'jumpwxappid',
      label: '跳转小程序appid',
      value: undefined,
      type: 1,
      isrow: true
    }, {
      key: 'needmobile',
      label: '手机号验证',
      value: undefined,
      type: 13,
      selectarr: [{ key: '关', value: 0 }, { key: '开', value: 1 }]
    }, {
      key: 'needregister',
      label: '注册验证',
      value: undefined,
      type: 13,
      selectarr: [{ key: '关', value: 0 }, { key: '开', value: 1 }]
    }, {
      key: 'sort',
      label: '排序',
      value: undefined,
      type: 7,
      isrow: true
    },]
  })
}



// WEBPACK FOOTER //
// ./src/utils/minxins.js